export const isChrome = navigator.userAgent.includes('Chrome');

export const isSafari = navigator.userAgent.includes('Safari') && !isChrome;

export const isFirefox = navigator.userAgent.includes('Firefox');

export const isInternetExplorer =
    navigator.userAgent.includes('MSIE') || !!(document as { documentMode?: unknown }).documentMode;
